import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import styles from './navbar.module.scss';
import profileImage from '../../../assets/profile.png';
import { GiHamburgerMenu } from "react-icons/gi";
import { setHam } from '../../../app/Slice/hamSlice';
import { setAccount, setAuth, setAuthBoolean, setUserName } from '../../../app/Slice/authSlice';
import logo from '../../../assets/company.png';
import axios from 'axios';
import { baseUrl } from '../../../app/shared/baseUrl';
import { CSSProperties, useEffect } from 'react';
import finvtech from '../../../assets/finvtech.png';
import index from '../../../assets/indexinfotech.png';
import think from '../../../assets/thinknextitsolution.png';
import trust from '../../../assets/trustEgo.png';
import algo from '../../../assets/algoadvisor.jpeg'


export default function Navbar(){
    const accountName = useAppSelector((state) => state.auth)
    const hamStatus = useAppSelector((state)=>state.ham);
    const dispatch = useAppDispatch()

    function setLogout(){
        dispatch(setUserName('Unknown'));
        dispatch(setAuth(''));
        dispatch(setAuthBoolean(false));
    }

    useEffect(()=>{
        getAddedBrokers();
        getDetails();
    },[])

    async function getAddedBrokers(){
        try {
            const response = await axios.get(`${baseUrl}/api/v1/broker-info/get-added-brokers`,{
                headers:{
                    'Authorization':`Bearer ${accountName.authCode}`,
                    'Content-Type':'application/json'
                    }
            });
        } catch (error:any) {
            if(error.response.status===401){
                setLogout();
            }
        }
    }

    async function getDetails(){
        console.log('called');
        try {
            const response = await axios.get(`${baseUrl}/api/tenant/get-comany-info`);
            console.log(response.data);
            if (response.status === 200) {
                console.log(response.data.company_name);
                dispatch(setAccount(response.data.company_name));
            }
        } catch (error: any) {
            console.log("the response is "+error);
            dispatch(setAccount("UnKnown"))
        }
    }

    const getLogoStyle = () => {
        switch (accountName.accountName) {
            case "Finvtech":
                return { height: "2rem" , backgroundColor: "white"};
            case "Indexinfotech":
                return { height: "3rem" };
            case "Thinknextitsolution":
                return { height: "3.2rem" , backgroundColor: "white", padding: "0 2rem"};
            case "Trustigo":
                return { height: "2.5rem" , padding: "0 1.5rem", background:'white'};
            case "Algoadvisor":
                return { height: "3rem", width:"12rem",  objectFit: "cover" as CSSProperties["objectFit"], backgroundColor: "white", };
          default:
            return {padding: "0 1.5rem", height: "2.5rem", backgroundColor: "white"}; 
        }
      };

      const getLogoImage = () => {
        switch (accountName.accountName) {
            case "Finvtech":
                return finvtech;
            case "Indexinfotech":
                return index;
            case "Thinknextitsolution":
                return think;
            case "Trustigo":
                return trust;
            case "Algoadvisor":
                return algo;
          default:
            return ''; 
        }
      };

    return(
        <nav>
            { accountName.auth ? <div onClick={()=>{dispatch(setHam(!hamStatus))}} className={styles.ham}><GiHamburgerMenu color='white' size={24} /></div> : <></>}
             {/* <img style={ { height: "3rem" }}  src={index} alt={''} className={styles.logo}/>  */}
            <img style={getLogoStyle()}  src={getLogoImage()} alt={accountName.accountName} className={styles.logo}/>
            {/* {accountName.accountName==='Finvtech' ? <img style={{height:"2.5rem"}} src={logo}/> :  <p  className={styles.left}>{accountName.accountName}</p>} */}
            {
                accountName.auth ?
                <div  className={styles.right}>
                <div className={styles.account}>
                    <p className={styles.name}>{accountName.userName}</p>
                    <p className={styles.plan}>{accountName.sub}</p>
                </div>
                <div className={styles.image}>
                    <img src={profileImage} />
                </div>
            </div>
            :
            <div></div>
            }
            <div className={styles.rightMobile}/>
        </nav>
    )
}